// The selection of the position grid, handed across a re-render. Every server-side step of the
// grid (structure, undo, details, catalog insert) answers with the whole grid, whose controllers
// reconnect with nothing selected; the controller that started the step leaves here what to
// select, keyed by the grid's storage key, and position-structure picks it up on connect.
//
// { rowId, column } names a row; { knownIds, column } means "the row that is new"; `fromServer`
// means the row the answer names (data-position-structure-select-value). `closePicker` closes the
// catalog picker once the insert it was opened for has landed.
export const handoff = new Map()
